import { Suspense } from 'react';
import {
  Routes, Route, useNavigate, useLocation, useParams, useSearchParams, Navigate,
} from 'react-router-dom';
import { getAccessToken } from '@/utils/auth';
import routes from './routes';

// 统一处理组件渲染：在这里可以做一些权限校验等...处理
function Element(props) {
  const { component: Component, name } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [usp] = useSearchParams();
  const token = getAccessToken() || window.atob(usp.get('t'));
  if (!token) {
    if (name === 'login' || name === 'external' || name === 'freeLogin') {
      return <Component navigate={navigate} location={location} params={params} usp={usp} />;
    }
    return <Navigate to="/login" replace />;
  }
  return <Component navigate={navigate} location={location} params={params} usp={usp} />;
}

// 递归创建Route
const createRouter = (routeList) => (
  routeList.map((item, index) => {
    const { path, children } = item;
    return (
      <Route key={index} path={path} element={<Element {...item} />}>
        { Array.isArray(children) ? createRouter(children) : null }
      </Route>
    );
  })
);

// 路由容器
export default function RouterView() {
  return (
    <Suspense fallback={<>加载中...</>}>
      <Routes>
        {createRouter(routes)}
      </Routes>
    </Suspense>
  );
}
